import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import "./number-text.scss";

const fontSizes = {
  xs: "0.625rem",
  sm: "0.75rem",
  md: "0.875rem",
  lg: "1rem",
  xl: "1.125rem",
  "2xl": "1.25rem",
  "3xl": "1.375rem",
  "4xl": "1.5rem",
  "5xl": "1.75rem",
  "6xl": "2rem"
};
const getFontSize = size => fontSizes[size] ?? "inherit";

const fontWeights = [300, 400, 500, 600, 700, 800];
const getFontWeight = weight =>
  fontWeights.includes(weight) ? weight : "inherit";

const NumberText = ({
  children,
  fontWeight,
  className,
  as: Component = "span",
  fontSize,
  style,
  ...props
}) => {
  const defaultClasses = cx("oui-number-text", className);

  return (
    <Component
      className={defaultClasses}
      style={{
        ...style,
        fontSize: getFontSize(fontSize),
        fontWeight: getFontWeight(fontWeight)
      }}
      {...props}
    >
      {children}
    </Component>
  );
};

NumberText.propTypes = {
  children: PropTypes.node.isRequired,
  fontWeight: PropTypes.oneOf(fontWeights),
  className: PropTypes.string,
  as: PropTypes.elementType,
  fontSize: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", "xxl"]),
  style: PropTypes.object
};

export default NumberText;
